export default __webpack_public_path__ + "static/media/67-ProductionsDeferlantes.27f7050f.jpg";